module.exports = __webpack_public_path__ + "static/media/header.74b7d9b2.jpg";